import { type ComponentType, type ReactNode } from 'react'
import { styled } from '@mui/material/styles'

export const MEDIUM_BREAKPOINT = 900
export const SMALL_BREAKPOINT = 700

export const CardGridWrapper: ComponentType<{ children?: ReactNode }> = styled( 'div' )( ( { theme } ) => ( {
	display: 'grid',
	gridTemplateColumns: 'repeat(3, 1fr)',
	gap: theme.spacing( 2 ),

	[ theme.breakpoints.down( MEDIUM_BREAKPOINT ) ]: {
		gridTemplateColumns: 'repeat(2, 1fr)',
	},

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		gridTemplateColumns: '1fr',
	},
} ) )
